import { AbsenceReasonTypesEnum } from '../components/Absence/types'

/**
 * Formats a number for display with smart decimal handling
 * @param value - The number to format, can be null or undefined
 * @returns Formatted string: empty for null/undefined, 2 decimal places for all numeric values
 */
export const formatAbsenceHours = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return ''
  return Number(value).toFixed(2)
}

export const getPayApprovalHoursDisplayValue = (payApprovalHours: number, status: string) => {
  const value = status === 'Declined' ? 0 : payApprovalHours
  const isPending = value > 0 && status === 'Pending'
  
  return `${formatAbsenceHours(value)}${isPending ? ' (Pending)' : ''}`
}

export const getUnpaidHoursDisplayValue = (unpaidHours: number, discretionaryPayHours: number, status: string) => {
  const value = status === 'Declined' ? unpaidHours + discretionaryPayHours : unpaidHours
  return formatAbsenceHours(value)
}

/**
 * Checks if the given absence type is Bereavement or Funeral Attendance
 * @param absenceTypeId - The absence type ID to check
 * @returns True if the absence type is Bereavement or Funeral Attendance
 */
export const isBereavementOrFuneral = (absenceTypeId: number | undefined): boolean =>
  [
    AbsenceReasonTypesEnum.Bereavement,
    AbsenceReasonTypesEnum.FuneralAttendance,
  ].includes(absenceTypeId as AbsenceReasonTypesEnum)
